import { render } from "./ScheduleFormStepGeneral.vue?vue&type=template&id=24d29896"
import script from "./ScheduleFormStepGeneral.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormStepGeneral.vue?vue&type=script&lang=ts"
script.render = render

export default script